module.exports = __webpack_public_path__ + "img/20200613_135531.46eb70b1.jpg";